import React from "react";
import PublishingOverviewPanel from "@/components/PublishingOverviewPanel";

// Standalone route wrapper. The panel is now embeddable — see
// PublishingOverviewPanel.jsx. Keep this thin wrapper so any external bookmarks
// or previously shared URLs to /publishing-overview still resolve. Prefer the
// panel embedded inside a TL / CM / Department dashboard.
export default function PublishingOverview() {
  return <PublishingOverviewPanel />;
}
